import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CalendarPlusIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="calendarPlus" ref={ref} {...props}>
      <path d="M16.66,3.17V2.09a.75.75,0,0,0-1.5,0V3H11.49v-.9a.75.75,0,0,0-1.5,0V3H6.33v-.9a.75.75,0,0,0-1.5,0v1.1A3.56,3.56,0,0,0,2.41,6.56V17.14A3.58,3.58,0,0,0,6,20.71h5.95a.75.75,0,0,0,0-1.5H6a2.08,2.08,0,0,1-2.08-2.07V8.58H17.62v4.94a.75.75,0,0,0,1.5,0v-7A3.57,3.57,0,0,0,16.66,3.17ZM3.91,7.08V6.56A2.08,2.08,0,0,1,6,4.49h9.55a2.08,2.08,0,0,1,2.08,2.07v.52ZM21.54,20a.74.74,0,0,1-.75.75H19.12V22.4a.75.75,0,0,1-1.5,0V20.71H15.94a.75.75,0,1,1,0-1.5h1.68V17.52a.75.75,0,0,1,1.5,0v1.69h1.67A.75.75,0,0,1,21.54,20Z" />
    </Icon>
  ),
) as IconWithRender;

CalendarPlusIcon.displayName = 'CalendarPlusIcon';
CalendarPlusIcon.renderIcon = (props) => <CalendarPlusIcon {...props} />;
export default CalendarPlusIcon;
